import { getLastUserFromDevice } from './last-user'
import { platform } from '../device/platform'
import Cookie, { AUTH_COOKIE_NAME } from './Cookies'
import isTokenExpired from './is-token-expired'
import { getUserIdByToken } from './get-user-from-token'
import { filesystem } from '../init'
import { isValidJWT } from './validate-token'
import { removeQueryParam } from '../../utils/remove-query-param'

export const QUERY_PARAM_TOKEN = 'tkn'

export default async function getMemoryToken (): Promise<string | undefined> {
  const urlToken = new URLSearchParams(window.location.search).get(QUERY_PARAM_TOKEN)
  if (urlToken != null && urlToken !== '' && isValidJWT(urlToken)) {
    Cookie.erase(AUTH_COOKIE_NAME)
    Cookie.set(AUTH_COOKIE_NAME, urlToken)
    removeQueryParam(QUERY_PARAM_TOKEN)
    return urlToken
  }
  if (platform === 'web') {
    return Cookie.get(AUTH_COOKIE_NAME)
  } else {
    return await getLastUserFromDevice()
      .then(async lastUserId => {
        if (lastUserId !== undefined && filesystem !== undefined) {
          await filesystem.setUser(lastUserId)
          const tokenFromMobile = await filesystem.read<string>(filesystem.getPath('token'))
          if (tokenFromMobile === undefined || tokenFromMobile === '' || tokenFromMobile === '-' || isTokenExpired(tokenFromMobile)) {
            await filesystem.write(filesystem.getPath('token'), '')
          } else {
            return tokenFromMobile
          }
        }
      })
  }
}

export async function updateMemoryToken (token: string): Promise<void> {
  if (platform === 'web') {
    Cookie.erase(AUTH_COOKIE_NAME)
    return Cookie.set(AUTH_COOKIE_NAME, token)
  } else {
    const userId = getUserIdByToken(token)
    if (userId !== undefined && filesystem !== undefined) {
      return await filesystem.write(filesystem.getPath('token'), token)
    }
  }
}
